import React from "react";
import { Link } from "react-router-dom";
import { Breadcrumb } from "../../components/Breadcrumb";

export const Finance = () => {
    document.title = "Maliyyə";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Maliyyə", value: "/finance", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <h2 className="my-4">Maliyyə</h2>
                <div className="row g-4">
                    <div className="col-12">
                        <Link to={"payments"}>Ödənişlər</Link>
                    </div>
                    <div className="col-12">
                        <Link to={"debts"}>Borclar</Link>
                    </div>
                </div>
            </div>
        </div>
    );
};
